import React from 'react'
import { Image, Text, } from 'components/library'
import './TooltipModal.css'

class TooltipModal extends React.Component {

  state = {
    modal: false,
  }

  render() {
    return (
      <div className="TooltipModal">
        <div className={`Tooltip-point Tooltip-${this.props.modalNr}`}>
          <div className="Tooltip-inner">
            <div className="Tooltip" onClick={() => (this.setState({ modal: 0, }))}>
              <Text>{this.props.tooltipTitle}</Text>
            </div>
          </div>
        </div>

        {this.state.modal !== false &&
          <div className="Modal-inner">
            <div>
              <div>
                <Image src={this.props.modalImage}/>
                <a onClick={() => (this.setState({ modal: false, }))}><i className="sh-icon sh-icon-close"></i></a>
              </div>
              <div>
                <Text><strong>{this.props.modalTitle}</strong></Text>
                <Text>{this.props.modalContent}</Text>
              </div>
            </div>
            <div className="Modal-underlay" onClick={() => (this.setState({ modal: false, }))} ></div>
          </div>
        }
      </div>
    )
  }
}

export { TooltipModal }



// WEBPACK FOOTER //
// ./src/content/chapters/04/01/component/TooltipModal.js